// 终止模拟的确认浮层 / Confirm-before-stop simulation modal.
// 强调"终止后 Credit 不会退回"，避免用户误触。按 AGENTS.md 约定不响应外部点击 / Escape。
// Emphasises the credit-is-non-refundable consequence and follows AGENTS.md's
// "no backdrop / Escape dismiss" rule — button-only exits.

/**
 * 弹出终止确认；resolve(true) 代表用户选择继续终止 / Resolves true only on continue.
 */
export function showStopSimulationModal(): Promise<boolean> {
  const root = document.getElementById("stop-simulation-modal");
  if (!root) throw new Error("#stop-simulation-modal mount missing");

  return new Promise<boolean>((resolve) => {
    root.hidden = false;
    root.innerHTML = `
      <div class="overlay"></div>
      <div class="modal stop-sim-modal">
        <div class="stop-sim-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor"
            stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2 1.5 21h21z" />
            <line x1="12" y1="9" x2="12" y2="14" />
            <circle cx="12" cy="17.5" r="1.1" fill="currentColor" stroke="none" />
          </svg>
        </div>
        <h3>Stop simulation?</h3>
        <p class="stop-sim-desc">Stopping will end the task immediately. <strong>Credit already spent on this simulation will not be refunded</strong>, and progress cannot be resumed. If you only want to check logs later, you can close the page; the simulation will keep running in the background.</p>
        <div class="stop-sim-actions">
          <button type="button" class="button ghost stop-sim-cancel">Cancel</button>
          <button type="button" class="button danger stop-sim-ok">Stop Simulation</button>
        </div>
      </div>
    `;

    const close = (ok: boolean) => {
      root.hidden = true;
      root.innerHTML = "";
      resolve(ok);
    };

    root.querySelector<HTMLButtonElement>(".stop-sim-cancel")
      ?.addEventListener("click", () => close(false));
    root.querySelector<HTMLButtonElement>(".stop-sim-ok")
      ?.addEventListener("click", () => close(true));
  });
}
